import { FIN_CRC_COUPONS_ITEM } from './fin-crc-coupons.js'
import { FIN_CRC_COUPON_CONTROL_ITEM } from './fin-crc-coupon-control.js'
import { FIN_CRC_SETTLEMENT_ITEM } from './fin-crc-settlement.js'
import { FIN_CRC_CONFIG_ITEM } from './fin-crc-config.js'

/** @type {import('../help-index.js').HelpScreen} */
export const FIN_CRC_HELP = {
  screenId: 'fin-crc',
  label: 'Tarjetas',
  navPath: 'Finanzas → Tarjetas',
  keywords: [
    'tarjeta', 'tarjeta de crédito', 'tarjeta de débito', 'cupón', 'liquidación',
    'visa', 'mastercard', 'pos', 'terminal', 'procesadora',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Gestioná cobros con tarjeta de clientes: primero configurá marcas, procesadoras y terminales; los cupones surgen de los cobros; después controlá con el archivo de la procesadora y registrá liquidaciones en banco. Expandí cada tema para ver los pasos.',
  sidebarItems: [
    FIN_CRC_COUPONS_ITEM,
    FIN_CRC_COUPON_CONTROL_ITEM,
    FIN_CRC_SETTLEMENT_ITEM,
    FIN_CRC_CONFIG_ITEM,
  ],
}
